export default __webpack_public_path__ + "static/media/gallery_08.e8d4d98d.jpg";